import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-application-type-gt.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-application-type-gt.component.scss?ngResource";
import { Component } from "@angular/core";
import { ApplicationSearchConstants } from "../../../application-search-constants";
import { SharedConstants } from "../../../../../../shared/constants/shared.constants";
import { FormControl, FormGroup } from "@angular/forms";
import { ApplicationSearchService } from "../../../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../../app-controller.service";
import { AlertType } from "../../../../../../shared/models/alert";
let SearchApplicationTypeGtComponent = class SearchApplicationTypeGtComponent {
    applicationSearchService;
    aflaModuleStrategyService;
    appController;
    applicationTypeLabel = ApplicationSearchConstants.FORM_CONTROLS.applicationTypeLabel;
    applicationTypeFormControl = ApplicationSearchConstants.FORM_CONTROLS.applicationTypeFormControl;
    placeholder = SharedConstants.SEARCH_BY_DEFAULT;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    applicationTypeForm;
    applicationTypeList;
    applicationSearchCallback;
    getApplicationTypesForModuleSubscription;
    constructor(applicationSearchService, aflaModuleStrategyService, appController) {
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
    }
    ngOnInit() {
        this.setUpForm();
        this.getApplicationTypesForModuleSubscription = this.applicationSearchService.getApplicationTypesForModule(Number(this.appController.selectedModuleID))
            .subscribe((types) => {
            this.applicationTypeList = types.value;
        });
    }
    searchApplication($event) {
        const appType = this.applicationTypeForm.get(this.applicationTypeFormControl).value;
        if (appType !== "") {
            this.applicationSearchCallback(this.applicationSearchService.searchByApplicationType(appType, Number(this.appController.selectedModuleID), this.aflaModuleStrategyService));
        }
        else {
            this.appController.showMessage(`${SharedConstants.NO_OPTION_SELECTED}`, AlertType.Warning);
        }
    }
    setUpForm() {
        this.applicationTypeForm = new FormGroup({
            applicationTypeFormControl: new FormControl("")
        });
    }
    static ctorParameters = () => [
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService }
    ];
};
SearchApplicationTypeGtComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-application-type-gt",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], SearchApplicationTypeGtComponent);
export { SearchApplicationTypeGtComponent };
